import { render, staticRenderFns } from "./about-provider.vue?vue&type=template&id=301a8535&scoped=true&lang=pug&"
import script from "./about-provider.vue?vue&type=script&lang=js&"
export * from "./about-provider.vue?vue&type=script&lang=js&"
import style0 from "./about-provider.vue?vue&type=style&index=0&id=301a8535&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301a8535",
  null
  
)

/* custom blocks */
import block0 from "./about-provider.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/image.vue').default})
